import type * as api from '@gitbook/api-client';
import * as analytics from '@gitbook/app-analytics/client';
import { Icon } from '@gitbook/spine-icons';
import { Heading } from '@gitbook/spine-react';

import { apiClient } from '../../../state';
import { SiteQuickActionCard, SiteQuickActionCardIcon } from '../../Site';
import type { SpaceCreationOnCreateSpace } from './types';

interface DuplicateCardProps {
    space: api.Space;
    onCreateSpace: SpaceCreationOnCreateSpace;
}

export function DuplicateCard(props: DuplicateCardProps) {
    const { onCreateSpace, space } = props;
    return (
        <SiteQuickActionCard
            onPress={async () => {
                await onCreateSpace(async () => {
                    const { data: duplicatedSpace } = await apiClient.spaces.duplicateSpace(
                        space.id
                    );
                    analytics.logEvent(
                        analytics.createSpaceEvent(duplicatedSpace, {
                            type: 'space_create',
                            source: 'duplicate',
                        })
                    );
                    return duplicatedSpace;
                });
            }}
        >
            <SiteQuickActionCardIcon>
                <Icon.Copy />
            </SiteQuickActionCardIcon>
            <Heading>Duplicate content</Heading>
        </SiteQuickActionCard>
    );
}
